import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/auth/forgot-password`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (res.ok) {
        setSent(true);
      } else {
        const data = await res.json();
        setError(data.error || 'Ошибка отправки');
      }
    } catch {
      setError('Ошибка сети');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-md p-8 max-w-md w-full">
        <h1 className="text-2xl font-bold text-center mb-2">Забыли пароль?</h1>
        <p className="text-sm text-gray-500 text-center mb-6">
          Введите ваш email, на который зарегистрирован аккаунт в Mailora - мы отправим ссылку для сброса пароля.
        </p>

        {error && (
          <div className="bg-red-50 text-red-500 p-3 rounded-xl mb-4">{error}</div>
        )}

        {sent ? (
          <div className="bg-green-50 text-green-700 p-4 rounded-xl">
            <p className="font-medium mb-1">📧 Письмо отправлено</p>
            <p className="text-sm">
              Если <b>{email}</b> зарегистрирован в Mailora — на него отправилась ссылка
              для сброса пароля. Проверьте почту (возможно папку «Спам»).
            </p>
            <Link to="/login" className="inline-block mt-4 text-blue-600 hover:underline text-sm">
              ← Вернуться ко входу
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border rounded-xl px-4 py-2 focus:ring-2 focus:ring-blue-400 focus:outline-none"
                placeholder="your@email.com"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`w-full py-3 rounded-xl text-white transition ${
                loading ? 'bg-blue-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
              }`}
            >
              {loading ? 'Отправка...' : 'Отправить ссылку'}
            </button>
          </form>
        )}

        {!sent && (
          <p className="text-center mt-6 text-gray-600">
            Вспомнили?{' '}
            <Link to="/login" className="text-blue-600 hover:underline">Войти</Link>
          </p>
        )}
      </div>
    </div>
  );
}